import SoftwareDemo from "./SoftwareDemo";
import OurLocation from "./OurLocation";

const ScheduleaDemo = () => {
  return (
    <>
      <SoftwareDemo />
      <OurLocation />
    </>
  );
};

export default ScheduleaDemo;
